import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserId } from "../utils/Auth";
import API_BASE_URL from "../config";
import { useTheme } from "../context/ThemeContext";

const LoginPage = ({ setRole, setUserName }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { darkMode } = useTheme();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        throw new Error("Date de autentificare incorecte!");
      }

      const data = await response.json();
      if (data.token && data.role) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("role", data.role);
        setRole(data.role); // 🔥 Azonnali frissítés

        // 🔥 Azonnal lekérjük és beállítjuk a user nevet
        const userId = getUserId();
        localStorage.setItem("userId", userId);
        const token = localStorage.getItem("token");

        const userResponse = await fetch(`${API_BASE_URL}/api/users/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (userResponse.ok) {
          const userData = await userResponse.json();
          setUserName(userData.name); // 🔥 Azonnali frissítés
        }

        navigate("/dashboard");
      } else {
        throw new Error("Hibás bejelentkezési válasz!");
      }
    } catch (error) {
      console.error("❌ Hiba történt:", error);
      setError(error.message);
    }
  };

  return (
    <div className={`flex items-center justify-center h-screen ${darkMode ? "bg-gray-900" : "bg-gray-200"}`}>
      <div className={`p-8 rounded-lg shadow-lg max-w-md w-full ${darkMode ? "bg-gray-800 text-white" : "bg-white text-gray-900"}`}>
        {/* 🔥 Logo vagy cím */}
        <h2 className={`text-3xl font-bold text-center mb-6 ${darkMode ? "text-white" : "text-gray-900"}`}>
          Bun venit la <span className="text-red-600">Marmorex CRM</span>
        </h2>

        {/* 🔥 Hibaüzenet */}
        {error && <p className="text-red-500 text-sm text-center">{error}</p>}

        {/* 🔥 Bejelentkezési űrlap */}
        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className={`block font-medium ${darkMode ? "text-gray-300" : "text-gray-700"}`}>Email:</label>
            <input
              type="email"
              className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 ${darkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label className={`block font-medium ${darkMode ? "text-gray-300" : "text-gray-700"}`}>Parolă:</label>
            <input
              type="password"
              className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 ${darkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            className={`w-full font-bold py-2 px-4 rounded-lg transition duration-200 ${darkMode ? "bg-red-600 hover:bg-red-700 text-white" : "bg-red-600 hover:bg-red-700 text-white"}`}
          >
            Autentificare
          </button>
        </form>

        {/* 🔥 Regisztráció link */}
        {/* 
        <p className={`text-sm text-center mt-4 ${darkMode ? "text-gray-300" : "text-gray-700"}`}>
          Nu ai un cont?{" "}
          <a href="/register" className="text-red-600 hover:underline">
            Înregistrează-te
          </a>
        </p> 
        */}
      </div>
    </div>
  );
};

export default LoginPage;